module.exports = __webpack_public_path__ + "img/business-solutions-card1@2x.671a3f8f.png";